import React from 'react'
import * as XLSX from 'xlsx'
import CyberButton from './CyberButton'

const thStyle = (bg, color) => ({
  background: bg, color, fontWeight: 700, padding: '10px 14px',
  textAlign: 'center', fontSize: 12, whiteSpace: 'nowrap', border: '1px solid #424666',
})

const tdStyle = (align = 'center') => ({
  padding: '9px 14px', textAlign: align, fontSize: 14,
  border: '1px solid #2e3358', color: '#fff',
})

const summaryTdStyle = (bg, color) => ({
  ...tdStyle(), background: bg, color, fontWeight: 700, fontSize: 14,
})

function exportSnapshot(snapshot) {
  if (!snapshot) return
  const wb = XLSX.utils.book_new()
  const headers = ['OEM Name', 'Total Deployable', 'Communicating', '> 12h Ignition Off', 'Non-Communicating', 'No API']
  const totalRow = ['Total', snapshot.totalDeployable, snapshot.communicating, snapshot.ignOff12h, snapshot.nonCommunicating, snapshot.noApi]
  const dataRows = (snapshot.oemBreakdown || []).map(r => [r.oem, r.totalDeployable, r.communicating, r.ignOff12h, r.nonCommunicating, r.noApi])
  const ws = XLSX.utils.aoa_to_sheet([totalRow, [], headers, ...dataRows])
  ws['!cols'] = [20, 20, 18, 24, 22, 12].map(wch => ({ wch }))
  XLSX.utils.book_append_sheet(wb, ws, 'Fleet Snapshot')
  XLSX.writeFile(wb, `fleet_snapshot_${snapshot.date}_${snapshot.time?.slice(0, 5)?.replace(':', '')}.xlsx`)
}

export default function FleetSnapshotOemTable({ snapshot }) {
  if (!snapshot) return null
  const rows = snapshot.oemBreakdown || []

  return (
    <div style={{ marginTop: 28 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#fff', letterSpacing: 0.2 }}>
          Fleet Status Report — {snapshot.date} · {snapshot.time?.slice(0, 5)} IST
        </h2>
        <CyberButton onClick={() => exportSnapshot(snapshot)}>Export Excel</CyberButton>
      </div>

      <div style={{
        overflowX: 'auto', borderRadius: 8,
        border: '1px solid #424666',
        background: 'linear-gradient(180deg, #252a4a 0%, #1e2240 100%)',
        boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
      }}>
        <table className="fleet-oem-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#252a4a' }}>
              <th style={{ ...thStyle('#252a4a', '#a0a3bd'), textAlign: 'left', minWidth: 140 }}>OEM Name</th>
              <th style={thStyle('#5241a0', '#e9d5ff')}>Total Deployable</th>
              <th style={thStyle('#1a6347', '#6ee7b7')}>Communicating</th>
              <th style={thStyle('#614a00', '#fde68a')}>&gt; 12h Ignition Off</th>
              <th style={thStyle('#612525', '#fca5a5')}>Non-Communicating</th>
              <th style={thStyle('#1a4d78', '#93c5fd')}>No API</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.oem} style={{ background: i % 2 === 0 ? '#1e2240' : '#252a4a' }}>
                <td style={{ ...tdStyle('left'), fontWeight: 600, color: '#fff' }}>{r.oem}</td>
                <td style={{ ...tdStyle(), fontWeight: 700, color: '#fff' }}>{r.totalDeployable}</td>
                <td style={{ ...tdStyle(), fontWeight: 600, color: '#fff' }}>{r.communicating}</td>
                <td style={{ ...tdStyle(), fontWeight: 600, color: '#fff' }}>{r.ignOff12h}</td>
                <td style={{ ...tdStyle(), fontWeight: 600, color: '#fff' }}>{r.nonCommunicating}</td>
                <td style={{ ...tdStyle(), fontWeight: 600, color: '#fff' }}>{r.noApi}</td>
              </tr>
            ))}
            <tr style={{ background: '#131627' }}>
              <td style={{ ...tdStyle('left'), fontWeight: 700, color: '#fff', fontSize: 14 }}>Total</td>
              <td style={summaryTdStyle('rgba(109,40,217,0.45)', '#fff')}>{snapshot.totalDeployable}</td>
              <td style={summaryTdStyle('rgba(5,150,105,0.40)', '#fff')}>{snapshot.communicating}</td>
              <td style={summaryTdStyle('rgba(180,130,0,0.40)', '#fff')}>{snapshot.ignOff12h}</td>
              <td style={summaryTdStyle('rgba(220,38,38,0.40)', '#fff')}>{snapshot.nonCommunicating}</td>
              <td style={summaryTdStyle('rgba(14,116,144,0.45)', '#fff')}>{snapshot.noApi}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
